// extracted by mini-css-extract-plugin
module.exports = {"packingItem":"nnZhC","packingItem-name":"dm2Il","packingItem-overlay":"DSq9s","packingItem-checkmark":"lTgQ-","packingItem-price":"E5Zhj","packingItem-price-value":"DsyX6"};